// var shortCutImg = 'https://statich5clover.happyelements.com/clover-web.png';
// var shareImg = 'https://statich5clover.happyelements.com/clover-web-200.png';
var shortCutImg = 'https://statich5clover.happyelements.com/resource/share/bg/bg_1.jpg';
var shareImg = 'https://statich5clover.happyelements.com/resource/clover-web-200x200-or8.png';
var desc = '全新爆爽消消乐来袭，和我一起闯关吧！不用下载就能玩';
var title = '海滨消消乐';
const SnsMini = require("./SnsMini")

let sns = xClass("snsWechatgame", SnsMini)

var RewardAdDefaultId = [
    "adunit-34de19d876b5c4e6",
    "adunit-9e143efcc616d32d",
    "adunit-8bf0e1074915820c",
    "adunit-aae518807f61508b",
    "adunit-cb8f903a38052a4a",
    "adunit-45111f1ac4ea2bd3",
    "adunit-51c2bb3a020e6167",
    "adunit-aecd6349f664bd1b",
    "adunit-0488399a65f0fa7c",
    "adunit-b8098e21fc0a122b",
    "adunit-51c2bb3a020e6167",
    "adunit-67cd896daaf18425",
    "adunit-edc591238fb0a743"
]
/**
 * 普通key 后面跟上_Long代表配置了长广告位
 * 如果分组开启了可用长视频 优先用普通key加上 _Long检测有没有配置长视频 有则用长视频的id
 * 例：普通 FailAdd2Step  长视频 FailAdd2Step_Long
 */
var RewardAdId = {
    "FailAdd1Step":"adunit-51cfaf69bf9361f6",
    "FailAdd2Step":"adunit-67cd896daaf18425",
    "FailAdd2Step_Long":"adunit-b46ba85e8c02c4f6",
    "AddEnergyAd": "adunit-1b2060ff231d9395",
    "MarkExtraReward":"adunit-8bf0e1074915820c",
    "Remark":"adunit-34de19d876b5c4e6",
    "MarketGetCash":"adunit-0488399a65f0fa7c",
    "CashNotEnough":"adunit-b8098e21fc0a122b",
    "CoinNotEnough":"adunit-aae518807f61508b",
    "TopGetCoin":"adunit-18a99fe72a340225",
    "GoldMatchAddStep":"adunit-51c2bb3a020e6167",
    "CoinMatchAddStep":"adunit-cb8f903a38052a4a",
    "CoinMatchFailAddStep":"adunit-45111f1ac4ea2bd3",
    "CoinMatchReset":"adunit-45111f1ac4ea2bd3",
    "LimitBlockColloctionAddTime":"adunit-aecd6349f664bd1b",
    "Startegy":"adunit-9e143efcc616d32d",
    "PassLevelDoubleReward":"adunit-edc591238fb0a743",
    "UnlockIsland":"adunit-0488399a65f0fa7c",
    "AdProp": "adunit-99aaf505bccf8022",
    "AdStartProp" : "adunit-99aaf505bccf8022",
    "AdGoldTurn": "adunit-99aaf505bccf8022",
    "AdGoldTurn_Long": "adunit-b16f6452591cc065",//
    "AdRefreshInBattle": "adunit-99aaf505bccf8022",//关内免费刷新
    "AdRefreshInBattle_Long": "adunit-1b2060ff231d9395",
    "SeasideStarDoubleCollect":"adunit-edc591238fb0a743",//海滨之星视频双倍
    "ComplementStarAd": "adunit-1b2060ff231d9395", //补星道具获取广告

}

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    this._adDcName = 'wx_video_ad';
    this.rewardAdDefaultIdx = -1;
}

sns.prototype._packShareParam = function () {
    let param = {
        onShare: ()=> {
            let textConfig = TextsManager.getInstance().getRandomTexts('default')
            let imageInfo = this.decodeSafeLink(textConfig.bg)
            let shareInfo = {
                title: textConfig.content,
                imageUrl: imageInfo.imageUrl,
                imageUrlId: imageInfo.imageUrlId,
                query: this.getShareLinkStr({
                    textId: textConfig.textId
                })
            }
            console.log("用户分享上报")
            DnSdkTool.getInstance().track("SHARE",{
                item:"APP_MESSAGE"
            })
            return shareInfo
        }
    }
    return param;
}
// 判断广告位是否可以播放长视频
sns.prototype.isCanShowLongAd = function (adPos) {
    if (!this.long_video_switch){
        this.long_video_switch = {};
        var config = CfgManager.get("game");
        for (let i = 0; i < config.long_rewarded_video_switch.length; i++) {
            let conf = config.long_rewarded_video_switch[i];
            let confArr = conf.split(":");
            this.long_video_switch[confArr[0]] = confArr[1];
        }
    }
    cc.log("[AD]","snsWechatgame isCanShowLongAd this.long_video_switch adPos",this.long_video_switch,adPos);
    return this.long_video_switch[adPos] == 1;

}
/**
 * 转译广告位
 * @param adPos 广告id的名字
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    // UserManager.getInstance().userLabe.videoGroup
    cc.log("[AD]","snsWechatgame _translateAdPos adPos useDefaultId",adPos,useDefaultId);
    cc.log("[AD]","snsWechatgame _translateAdPos UserManager.getInstance().userLabel ",UserManager.getInstance().userLabel);
    // videoGroup

    //巨量腾讯替换激励视频广告位
    let channelAdId = transAdIdForChannel("RewardedVideoAd")
    if (channelAdId){
        return channelAdId
    }

    if (RewardAdId[adPos] && useDefaultId == false){
        let id = RewardAdId[adPos];
        if (UserManager.getInstance().userLabel && UserManager.getInstance().userLabel.videoGroup
        && this.isCanShowLongAd(adPos)){
            id = RewardAdId[adPos+"_Long"];//尝试获长视频
            cc.log("[AD]"," snsWechatgame _translateAdPos long id ",id);
            id = id ? id : RewardAdId[adPos];
        }
        cc.log("[AD]"," snsWechatgame _translateAdPos id ",id);
        return id;
    }else{
        if (this.rewardAdDefaultIdx == -1){
            return RewardAdDefaultId[0];
        }
        return RewardAdDefaultId[this.rewardAdDefaultIdx];
    }
}

sns.prototype.hasMoreRewardAdId = function(){
    if((this.rewardAdDefaultIdx+1) < RewardAdDefaultId.length){
        return true;
    }else{
        return false;
    }
}

sns.prototype.setNextRewardAdId = function(){
    this.rewardAdDefaultIdx += 1;
    console.log("setNextRewardAdId", this.rewardAdDefaultIdx)
}

sns.prototype.updateNameHeadAfterLogin = function(){
    var self = this
    QAGUI.getInstance().print("snsUserInfoIsExpire="+self.snsUserInfoIsExpire, "Preload")
    if (self.snsUserInfoIsExpire){
        if (self.snsUserInfoUpdateParams == null){
            QAGUI.getInstance().print("snsUserInfoUpdateParams  == null", "Preload")
            self.snsUserInfoUpdateStatus = 1
        }else{
            QAGUI.getInstance().print("AuthorizeHttp:"+Localhost.time(), "Preload")
            let http = AuthorizeHttp.new()
            http.addEventListener(Events.kComplete, (res)=>{
                self.snsUserInfoIsExpire = false
                self.snsUserInfoUpdateStatus = 2
                self.snsUserInfoIsExpire = null
                
                var profile = UserManager.getInstance().profile
                profile.headUrl = res.data.avatarUrl
                profile.name = res.data.nickName
            })
            http.addEventListener(Events.kError, ()=>{
                self.snsUserInfoIsExpire = false
                self.snsUserInfoUpdateStatus = 2
                self.snsUserInfoIsExpire = null
            })
            http.addEventListener(Events.kCancel, ()=>{
                self.snsUserInfoIsExpire = false
                self.snsUserInfoUpdateStatus = 2
                self.snsUserInfoIsExpire = null
            })

            self.snsUserInfoUpdateParams.openid = cc.UserDefault.getInstance().getStringForKey("h5game_openid")
            self.snsUserInfoUpdateParams.sessionid = cc.UserDefault.getInstance().getStringForKey("h5sdk_sessionid")
            http.load(self.snsUserInfoUpdateParams)
        }
    }
}

sns.prototype.getOpenKey = function (cb, sessionCallback, isPreGet, forceNewCode) {
    var self = this

    function sendLog(log) {
        let systemInfo = mini.getSystemInfoSync()
        log += " sdkVersion: " + systemInfo.SDKVersion + ", wxVersion: " + systemInfo.version + ", systemInfo: " + JSON.stringify(systemInfo)
        if (window.logCenter) {
            let msg = {
                message: "login fail: " + log
            }
            window.logCenter.log(msg)
        } else {
            cc.error("login fail: " + log)
        }
    }
    function showLoginFailModal(reason, log) {
        reason = reason || '登录失败请重试'
        sendLog(log)
        mini.showModal({
            title: reason,
            showCancel: false,
            success: function (res) {
                cb({failRetry:1});
            }
        })
    }

    let needCreateUserInfoBtn = false
    if (isPreGet){
        self.preGetting = true
    }
    function getUserInfo(){
        function onLoginSuccess(code, openid, sessionid){
            if (isPreGet){
                self.preGetting = false
                self.preGetCode = code
                return
            }
            // 检查本地缓存个人信息，默认的是nickName是Clover，头像是空
            let cachedInfo = Localhost.getSnsUserInfo()
            self.snsUserInfoIsExpire = false
            self.snsUserInfoUpdateParams = null
            self.snsUserInfoUpdateStatus = 0 // 0刚开始，1登录后调用update时还没有头像昵称，2完成
            console.log("[preload] cachedInfo", cachedInfo)
            if (cachedInfo){
                QAGUI.getInstance().print(`nickname=${cachedInfo.nickname}`, "Preload")
                QAGUI.getInstance().print(`image=${cachedInfo.image}`, "Preload")
            }
            if (cachedInfo && cachedInfo.nickname != "Clover" && cachedInfo.image != ""){
                QAGUI.getInstance().print("use cached userInfo", "Preload")
                cb({
                    code:code,
                    avatarUrl:cachedInfo.image,
                    rawData:'',
                    signature:'',
                    notUpdateAvatar:true
                })
                if (cachedInfo.expire == true){
                    // 个人信息过期了，先正常登录，但是需要重新获取个人信息
                    QAGUI.getInstance().print("cached userInfo is expire", "Preload")
                    self.snsUserInfoIsExpire = true
                }else{
                    return
                }
            }else{
                QAGUI.getInstance().print("no cached userInfo", "Preload")
                cb({
                    code:code,
                    avatarUrl:'https://ff.happyelements.com/xclover/clover-web@100.png'
                })
                self.snsUserInfoIsExpire = true
            }
            //判断是否授权，这些不需要卡登录进度
            QAGUI.getInstance().print("wx.getSetting 1:"+Localhost.time(), "Preload")
            mini.getSetting(
                {
                    success:function(res){
                        QAGUI.getInstance().print("wx.getSetting 2:"+Localhost.time(), "Preload")
                        if (res.authSetting != null && !res.authSetting["scope.userInfo"]){
                            needCreateUserInfoBtn = true
                        }
                        
                        //needCreateUserInfoBtn = true
                        if (needCreateUserInfoBtn && !self.userInfoBtn){
                            // if (code){
                            //     cb({
                            //         code:code,
                            //         avatarUrl:'https://ff.happyelements.com/xclover/clover-web@100.png'
                            //     })
                            // }else{
                            //     cb({
                            //         h5game_openid:openid,
                            //         h5sdk_sessionid:sessionid,
                            //     })
                            // }
                        }else{
                            QAGUI.getInstance().print("wx.getUserInfo 1:"+Localhost.time(), "Preload")
                            mini.getUserInfo({
                                withCredentials:true,
                                success:function(data){
                                    QAGUI.getInstance().print("wx.getUserInfo 2:"+Localhost.time(), "Preload")
                                    console.log("[preload] rawData", data.rawData)
                                    if (data.rawData){
                                        let infoData = JSON.parse(data.rawData)
                                        QAGUI.getInstance().print(`setSnsUserInfo ${infoData.nickName} ${infoData.avatarUrl}`, "Preload")
                                        Localhost.setSnsUserInfo(null, infoData.nickName, null, infoData.avatarUrl, null)
                                        if (self.snsUserInfoIsExpire){
                                            self.snsUserInfoUpdateParams = {
                                                rawData: data.rawData,
                                                signature: data.signature
                                            }
                                            if (self.snsUserInfoUpdateStatus == 1){
                                                self.updateNameHeadAfterLogin()
                                            }
                                        }
                                    }
                                    //cc.log("[####]getUserInfo success", data, code)
                                    //console.log("[####]on getUserInfo success:"+data.signature+" encry:"+data.encryptedData+" iv:"+data.iv)
                                    // if (code){
                                    //     cb({
                                    //         rawData:data.rawData,
                                    //         signature:data.signature,
                                    //         encryptedData:data.encryptedData,
                                    //         iv:data.iv,
                                    //         code:code
                                    //     })
                                    // }else{
                                    //     cb({
                                    //         h5game_openid:openid,
                                    //         h5sdk_sessionid:sessionid,
                                    //         rawData:data.rawData,
                                    //         signature:data.signature,
                                    //         encryptedData:data.encryptedData,
                                    //         iv:data.iv
                                    //     })
                                    //     window.logCenter.error(new Error("wx login by h5sdk_sessionid"), "wx_login")
                                    // }
                                },
                                fail:function(){
                                    console.log("[####]get user info failed")
                                    // showLoginFailModal(null, "getUserInfo fail")
                                    window.logCenter.error(new Error("wx login by h5sdk_sessionid"), "wx_login")
                                }
                            })
                        }
                    },
                    fail:function(){
                        console.log("getSetting failed")
                        // showLoginFailModal(null, "getSetting fail")
                        window.logCenter.error(new Error("wx.getSetting failed"), "wx_login")
                    }
                }
            )
        }

        //查看本地是否有登陆态
        let openid = cc.UserDefault.getInstance().getStringForKey("h5game_openid")
        if (forceNewCode){
            QAGUI.getInstance().print("forceNewCode", "Preload")
        }else{
            QAGUI.getInstance().print("recoveryFlag == null ", "Preload")
            // 预先获取到了code直接用
            if (isPreGet){
                QAGUI.getInstance().print("getOpenKey isPreGet", "Preload")
            }else if (self.preGetCode){
                onLoginSuccess(self.preGetCode)
                return
            }else if(self.preGetting){
                QAGUI.getInstance().print("waiting code", "Preload")
                setTimeout(()=>{
                    self.getOpenKey(cb, sessionCallback, isPreGet)
                },100)
                return
            }
        }
        //没有先登陆
        if (!openid || openid.length <= 1 || true)
        {
            console.log("[####]no openid login")
            QAGUI.getInstance().print("wxLogin 1:"+Localhost.time(), "Preload")
            mini.login({
                success:function(res){
                    QAGUI.getInstance().print("wxLogin 2:"+Localhost.time(), "Preload")
                    if (res.code){
                        onLoginSuccess(res.code)
                    }else{
                        console.log("[####]wx login failed no res.code")
                        showLoginFailModal(null, "login fail")
                        window.logCenter.error(new Error("wx.login failed err=no code"), "wx_login")
                    }
                },
                fail:function(err){
                    console.log("[####]wx login failed")
                    showLoginFailModal(null, "login fail")
                    window.logCenter.error(new Error("wx.login failed err="+err.errMsg), "wx_login")
                }
            })
        }
        //有登陆态验证是否过期
        else{
            mini.checkSession({
                success() {
                    console.log("[####]session is validate")
                    onLoginSuccess(
                        null,
                        cc.UserDefault.getInstance().getStringForKey("h5game_openid"),
                        cc.UserDefault.getInstance().getStringForKey("h5sdk_sessionid")
                        )
                },
                fail() {
                    console.log("[####]session is invalidate relogin")
                    mini.login({
                        success:function(res){
                            if (res.code){
                                onLoginSuccess(res.code)
                            }else{
                                console.log("[####]wx login failed no res.code")
                            }
                        },
                        fail:function(){
                            console.log("[####]wx login failed")
                        }
                    })
                }
              })
        }
    }

    getUserInfo()

    return
}

sns.prototype.checkAuthorizeWithUserBtn =  function (agreeCb, denyCb){
    var self = this

    console.log("!!!!wx check autiorize with user btn")
    function sendLog(log) {
        let systemInfo = mini.getSystemInfoSync()
        log += " sdkVersion: " + systemInfo.SDKVersion + ", wxVersion: " + systemInfo.version + ", systemInfo: " + JSON.stringify(systemInfo)
        if (window.logCenter) {
            let msg = {
                message: "login fail: " + log
            }
            window.logCenter.log(msg)
        } else {
            cc.error("login fail: " + log)
        }
    }

    function showLoginFailModal(reason, log) {
        reason = reason || '登录失败请重试'
        sendLog(log)
        mini.showModal({
            title: reason,
            showCancel: false,
            success: function (res) {
            }
        })
    }
    function showAuthorizeModal(agreeCb, denyCb) {
        mini.showModal({
            title: '用户未授权',
            content: '为正常使用程序功能，请按点击确定并在授权管理中选中允许访问用户信息',
            showCancel: false,
            success: function (res) {
                if (res.confirm) {
                    mini.openSetting({
                        success: function (res) {
                            if (res.authSetting != null && res.authSetting["scope.userInfo"]){
                                if (agreeCb){
                                    agreeCb()
                                }
                                refreshAuthorize()
                            }else{
                                if (denyCb){
                                    denyCb()
                                }
                            }
                        }
                    })
                }
            }
        })
    }

    let needCreateUserInfoBtn = false
    mini.getSetting(
        {
            success:function(res){
                if (res.authSetting != null && !res.authSetting["scope.userInfo"]){
                    needCreateUserInfoBtn = true
                }
                if (needCreateUserInfoBtn && !self.userInfoBtn){
                    let fs = cc.director.getOpenGLView().getFrameSize()
                    let scale = cc.view.getDevicePixelRatio() * fs.width / cc.winSize.width
                    let btnWidth = 120 * scale
                    let btnHeight = 72 * scale
                    let btnX = (fs.width - btnWidth) / 2
                    let btnY = ((cc.winSize.height - 300) / cc.winSize.height) * fs.height

                    self.userInfoBtn = mini.createUserInfoButton({
                        type: 'image',
                        image: 'https://statich5clover.happyelements.com/resource/upload/start_game.png',
                        withCredentials:true,
                        style: {
                            left: btnX,
                            top: btnY,
                            width: btnWidth,
                            height: btnHeight
                        }
                    })
                
                    let sdkVer = mini.getSystemInfoSync().SDKVersion
                    sdkVer = sdkVer.replace(/\./g, "")
                    sdkVer = sdkVer.substring(0, 3)
                    console.log("[####get sdkVer "+ sdkVer)
                
                    self.userInfoBtn.onTap(function (data) {

                        self.userInfoBtn.destroy()
                        self.userInfoBtn = null
                        if(data.signature)
                        {
                            if (agreeCb){
                                agreeCb()
                            }
                            refreshAuthorize()
                        }
                        else if (
                            data.errMsg.includes("deny") || 
                            data.errMsg == "getUserInfo:fail scope unauthorized") {
                            showAuthorizeModal(agreeCb, denyCb)
                        }
                        else {
                            showLoginFailModal(null, "ontap fail: " + data.errMsg)
                        }
                    })
                }else{
                    if (agreeCb){
                        agreeCb()
                    }
                }

            },
            fail:function(){
                console.warn("get setting failed")
                if (agreeCb){
                    agreeCb()
                }
            }
        }
    )
}


sns.prototype.onLoginFinish = function(openid, sessionid){
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]login finish failed no openid or sessionid")
    }
}

sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    mini.hideKeyboard()
}

sns.prototype.decodeSafeLink = function (url) {
    let imageUrlId = null
    let imageUrl = url
    if (url.startsWith("sflink:")) {
        let info = url.replace("sflink:", "").split("||")
        imageUrlId = info[0]
        imageUrl = info[1]
    }
    return { 
        imageUrl:imageUrl,
        imageUrlId:imageUrlId,
    }
}

sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback, needRealCallback = false) {
    let self = this

    if (platform == XcloverPlatform.wechatgame && mini.shareAppMessage) {
        imageUrl = imageUrl ? imageUrl : shortCutImg
        let imageInfo = self.decodeSafeLink(imageUrl)
        title = title ? title : "海滨消消乐"
        //分享链接加上textId
        if (textId && _link) {
            _link = _link + '&textId=' + textId;
        }
        let share = {
            shareInfo: {
                title: title,
                imageUrl: imageInfo.imageUrl,
                imageUrlId: imageInfo.imageUrlId,
                query: _link
            }
        }
        //  由于微信分享关闭了回调，因此只能通过用户返回小游戏做回调处理
        if (needRealCallback) {
            function onShowCallback() {
                mini.offShow(onShowCallback);
                callback({
                    retCode: 0,
                    data: {
                        retCode: 2,
                        msg: "分享成功！"
                    }
                });
            }

            mini.onShow(onShowCallback);
        } else {
            setTimeout(function(){
                callback({
                    retCode: 0,
                    data: {
                        retCode: 2,
                        msg: "分享成功！"
                    }
                })
            }, 1000)
        }
        cc.log("wx share", share)

        mini.shareAppMessage(share.shareInfo)
        DnSdkTool.getInstance().track("SHARE",{
            item:"APP_MESSAGE"
        })
    } else {
        callback({
            retCode: 2,
            data: {
                retCode: 2,
                msg: "分享未发送！"
            }
        })
    }
}

sns.prototype.popBack = function () {
    window.mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })
}

/**
 * 
 * @param {*} img      背景 Image path
 * @param {*} info 
 *                     {
 *                         avatar: avatar path
 *                         avatar2: avatar2 path
 *                         nickname: nickname
 *                         sytle: font 的 css 样式, eg: '48px serif'
 *                         avatarPos: {x:100, y:100}
 *                         nicknamePos: {x:100, y:100}
 *                         radius: 头像半径
 *                     }
 * @param {*} callback 
 */
sns.prototype.drawDataToImg = function (bgpath, info, callback) {

    let oldCallback = callback
    let called = false
    callback = function (path) {
        if (!called) {
            oldCallback && oldCallback(path)
            called = true
        }
    }

    // 如果没有参数直接返回
    if (!info) {
        setTimeout(() => {
            callback && callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
        }, 0);
        return
    }

    let safeImgMap = {}
    let drawImage = function() {
        let time = 1
        let avatarImg = null
        let avatarImgFail = null
        let radius = info.radius || 100 / 2
        if (info.avatar) {
            time ++
            avatarImg = mini.createImage()
        }
        if (info.avatarFail) {
            time ++
            avatarImgFail = mini.createImage()
        }
        let mycanvas = mini.createCanvas()
        let context = mycanvas.getContext("2d")
        let loadCallback = timeLimitCallbackFunc(onLoadingComplete, time)
        let img = mini.createImage()

        let fillStyle = info.fillSytle || "white"

        function onLoadingComplete() {

            mycanvas.width = img.width
            mycanvas.height = img.height

            // 背景
            context.drawImage(img, 0, 0)

            // 头像
            if (info.avatar) {
                context.beginPath()
                context.arc(info.avatarPos.x + radius, info.avatarPos.y + radius, radius, 0, 2 * Math.PI)
                context.closePath()
                context.save()
                context.clip()
                context.drawImage(avatarImg, info.avatarPos.x, info.avatarPos.y, radius * 2, radius * 2) // 头像
                context.restore()
            }

            // 失败者头像
            if (info.avatarFail) {
                context.beginPath()
                let failRadius = info.avatarFailRaidus || radius
                context.arc(info.avatarFailPos.x + failRadius, info.avatarFailPos.y + failRadius, failRadius, 0, 2 * Math.PI)
                context.closePath()
                context.save()
                context.clip()
                context.drawImage(avatarImgFail, info.avatarFailPos.x, info.avatarFailPos.y, failRadius * 2, failRadius * 2) // 头像
                context.restore()
            }

            // 名字
            if (info.nickname) {
                context.save()
                context.fillStyle = fillStyle
                context.font = info.style
                context.fillText(info.nickname, info.nicknamePos.x, info.nicknamePos.y)
                context.restore()
            }

            // levelDesc
            if (info.levelDesc) {
                context.save()
                context.fillStyle = fillStyle
                context.font = info.levelStyle
                let width = context.measureText(info.levelDesc).width
                context.fillText(info.levelDesc, (img.width - width) / 2, info.levelDescPos.y)
                context.restore()
            }

            // score
            if (info.score) {
                context.save()
                context.fillStyle = fillStyle
                context.font = info.scoreStyle
                let width = context.measureText(info.score).width
                context.fillText(info.score, (img.width - width) / 2, info.scorePos.y)
                context.restore()
            }

            try {
                let tempFilePath = null
                tempFilePath = mycanvas.toTempFilePathSync({
                    x: 0,
                    y: 0,
                    width: img.width,
                    height: img.height,
                    destWidth: img.width,
                    destHeight: img.height
                })
                callback(tempFilePath)
                if (img) {
                    img.src = ""
                    img = null
                }
                if (avatarImg) {
                    avatarImg.src = ""
                    avatarImg = null
                }
                if (avatarImgFail) {
                    avatarImgFail.src = ""
                    avatarImgFail = null
                }
                mycanvas  = null
                context   = null
            } catch (error) {
                callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
                console.error(error)
            }
        }

        let errorCallback = ()=> {
            callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
        }
        img.src = safeImgMap[cc.loader.getUrl(cc.loader.resPath, bgpath)]
        img.onload = loadCallback
        img.onerror = errorCallback
        if (avatarImg) {
            avatarImg.src = safeImgMap[info.avatar]
            avatarImg.onload = loadCallback
            avatarImg.onerror = errorCallback
        }
        if (avatarImgFail) {
            avatarImgFail.src = safeImgMap[info.avatarFail]
            avatarImgFail.onload = loadCallback
            avatarImgFail.onerror = errorCallback
        }
    }
    
    let imgList = [cc.loader.getUrl(cc.loader.resPath, bgpath)];
    if (info.avatar) imgList.push(info.avatar);
    if (info.avatarFail) imgList.push(info.avatarFail);

    if (mini.useStrictImgMode()) {
        imgList.forEach(v=> {
            mini.downloadFile({
                url: v,
                success: res => {
                    safeImgMap[v] = (res.statusCode === 200? res.tempFilePath: "") || ""
                    if (Object.keys(safeImgMap).length === imgList.length) 
                        drawImage();
                },
                fail: err=> {
                    safeImgMap[v] = '';
                    if (Object.keys(safeImgMap).length === imgList.length) 
                        drawImage();
                },
                extractmap: {
                    picurl: v,
                    node: 'sns.drawDataToImg',
                }
            })
        });
        
    } else {
        imgList.forEach(v=> safeImgMap[v] = v);
        drawImage();
    }
    // setTimeout(() => {
    //     callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
    // }, 10*1000);
}


/**
 * 是否允许开启Pvp
 */
sns.prototype.allowPvp = function() {
    return true;
}

/**
 * 是否支持互动分享模块
 */
sns.prototype.allowInteractiveInvite = function() {
    // return false
    let systemInfo = mini.getSystemInfoSync()
    // 接口实在太多了，用版本号判断
    // 所需接口里版本号最大的是onShareMessageToFriend
    return vaildVersion(systemInfo.SDKVersion, "2.9.4");
}

/**
 * 是否支持新排行互动托管功能
 */
sns.prototype.allowInteractiveRank = function() {
    // return false
    let systemInfo = mini.getSystemInfoSync()
    cc.log("allowInteractiveRank systemInfo ",systemInfo)
    return vaildVersion(systemInfo.SDKVersion, "2.9.4");
}

/**
 * 是否支持跳转pc端
 */
sns.prototype.allowHandoff = function() {
    let systemInfo = mini.getSystemInfoSync()
    return vaildVersion(systemInfo.SDKVersion, "2.14.4");
}

/**
 * 显示插屏广告用
 */
sns.prototype.setNeedShowInterstitialAdName = function(name, flag) {
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    this.needShowInterstitialAdName[name] = flag;
}

sns.prototype.getNeedShowInterstitialAdName = function(name) {
    cc.log(this.needShowInterstitialAdName)
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    return this.needShowInterstitialAdName[name];
}

/**
 * 获取用户所在省份
 * 不涉及权限判断
 * @param lang 语言 目前只支持中文
 * @param callback(err: object, data: { province, lang })
 * 
 */
sns.prototype.fetchProvince = function(callback, lang = "zh_CN") {
    var location = UserManager.getInstance().location
    if (location) {
        callback && callback(null, {
            country: location.country,
            province: location.province,
            lang: "zh_CN"
        })
    } else {
        let uid = UserManager.getInstance().uid || "null"
        window.logCenter && logCenter.error(new Error(`${uid}: location == null!`), 'LocationError')
        callback && callback(null, null); 
    }

    
    // mini.getUserInfo({
    //     withCredentials: false,
    //     lang: lang,
    //     success: res=> {
    //         console.log("[SnsProxy]", "fetchProvince. mini.getUserInfo success.", res)
    //         let userInfo = res && res.userInfo;
    //         if (userInfo) {
    //             let { province, language, country } = userInfo;
    //             callback && callback(null, {
    //                 country,
    //                 province,
    //                 lang: language
    //             })
    //         } else {
    //             callback && callback(null, {
    //                 country: "",
    //                 province: "",
    //                 lang: lang
    //             })
    //         }
    //     },
    //     fail: res=> {
    //         callback && callback(res, null); 
    //     }
    // });
}

/**
 * 是否处于无现金社会
 * 这个值为true时，所有的【购买】文本会被替换为【兑换】
 * 在platform = wechatgame 且 os=iOS的情况下为true
 * 微信IOS平台不允许出现代币购买的文本
 */
sns.prototype.isBuyBan = function() {
    return mini.getOS() == MiniOS.IOS
}

// 检查是否需要去请求订阅
sns.prototype.checkNeedRequestSubscribeSystemMessage = function (MSG_TYPE, callback) {
    console.log("[subscribe] checkNeedRequestSubscribeSystemMessage", MSG_TYPE)
    var self = this
    //判断是否授权
    mini.getSetting({
        withSubscriptions: true,
        success:function(res){
            console.log("[subscribe] subscriptionsSetting res", res)
            let needRequest = false
            if (res && res.subscriptionsSetting){
                let setting = res.subscriptionsSetting
                if (setting.mainSwitch == false){
                    needRequest = true
                }else if (setting.itemSettings && setting.itemSettings[MSG_TYPE] != "accept"){
                    needRequest = true
                }
            }
            console.log("[subscribe] needRequest", needRequest)
            if (callback){
                callback(needRequest)
            }
        },
        fail:function(){
            if (callback){
                callback(false)
            }
        }
    })  
}

sns.prototype.tryRequestSubscribeSystemMessage = function (MSG_TYPE, callback) {
    console.log("[subscribe] mini.requestSubscribeSystemMessage", MSG_TYPE)
    let self = this
    self.requestSubscribeSystemMessageFinish = false
    mini.requestSubscribeSystemMessage({
        msgTypeList: [MSG_TYPE],
        success (res) {
            console.log("[subscribe] tryRequestSubscribeSystemMessage success", res)
            if (self.requestSubscribeSystemMessageFinish == false && callback){
                self.requestSubscribeSystemMessageFinish = true
                callback(true)
            }
        },
        fail (res) {
            console.log("[subscribe] tryRequestSubscribeSystemMessage fail", res)
            if (self.requestSubscribeSystemMessageFinish == false && callback){
                self.requestSubscribeSystemMessageFinish = true
                callback(false)
            }
        },
        complete (res) {
            console.log("[subscribe] tryRequestSubscribeSystemMessage complete", res)
            if (self.requestSubscribeSystemMessageFinish == false && callback){
                self.requestSubscribeSystemMessageFinish = true
                callback(false)
            }
        }
    })
}

/**
 * 处理平台会错信息
 * 用于上传错误日志等
 * 不可面向用户展示
 * @param {*} res 
 * @return string
 */
sns.prototype.getErrorMessage = function(res) {
    if (!res)
        return "";
    else if (typeof res === "string")
        return res;
    else {
        try{
            return JSON.stringify(res);
        } catch(e){
            return res.errMsg || ""
        }
    }
}
/**
 * 版本号比较
 * @return 
 *  1: v1 > v2
 *  0: v1 = v2
 *  -1: v1 < v2
 */
function compareVersion(v1, v2) {
    let ary1 = v1.split('.')
    let ary2 = v2.split('.')
    const len = Math.max(ary1.length, ary2.length)
  
    while (ary1.length < len) {
        ary1.push('0')
    }
    while (ary2.length < len) {
        ary2.push('0')
    }
  
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(ary1[i])
      const num2 = parseInt(ary2[i])
  
      if (num1 > num2) {
        return 1
      } else if (num1 < num2) {
        return -1
      }
    }
  
    return 0
}

/**
 * 校验版本号
 */
function vaildVersion(version, minVersion) {
    return compareVersion(version, minVersion) >= 0
}

module.exports = sns